import { __assign, __awaiter, __generator } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { applyOfficeIdentity, httpGet } from '@office-start/xhr-service';
import { getMasterCollection, isFirstUse } from '../UserStorageService';
export function getUserStorageItem(key, options, forceRefresh, remoteAttempts) {
    var _this = this;
    if (forceRefresh === void 0) { forceRefresh = false; }
    if (remoteAttempts === void 0) { remoteAttempts = 1; }
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var masterCollection, value, identity, requestConfig, retryAttempt;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    masterCollection = getMasterCollection();
                    if (masterCollection.hasOwnProperty(key) && !forceRefresh) {
                        value = Array.isArray(masterCollection[key])
                            ? masterCollection[key]
                            : __assign({}, masterCollection[key]);
                        resolve(value);
                        return [2 /*return*/];
                    }
                    // Short-circuit the case when it is known that storage does not contain any values yet or no remote fetch is desired
                    if (isFirstUse() || remoteAttempts < 1) {
                        // Return undefined as indicator that value has not been found
                        resolve(undefined);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, options.getIdentity()];
                case 1:
                    identity = _a.sent();
                    // Check if a token is required and msa
                    if (options.jwtAuthEnabled && identity.isMsa) {
                        reject('User storage does not support roaming');
                        return [2 /*return*/];
                    }
                    requestConfig = {};
                    return [4 /*yield*/, applyOfficeIdentity(requestConfig, options.inMockMode, options.workload, options.getIdentity)];
                case 2:
                    _a.sent();
                    retryAttempt = 0;
                    httpGet(KnownInstrumentationEvents.OfficeHomeStorageReadRequest, "OfficeHomeStorage_Read" /* OfficeHomeStorageReadRequest */, options.officeHomeApiRoot + "/api/userstorage/" + key + "/", requestConfig, options.jwtAuthEnabled, options.getAccessToken, options.officeHomeApiRoot, options.correlationId, "OfficeHome" /* OfficeHome */, {
                        populateRequestEvent: function (_result, params) {
                            params["ElementId" /* ElementId */] = key;
                            params["Retry" /* Retry */] = (retryAttempt++).toString();
                        },
                        isRetriableError: function (status) {
                            return status !== 404 /* NotFound */ &&
                                status !== 403 /* Forbidden */;
                        },
                    })
                        .then(function (result) {
                        if (result.data) {
                            masterCollection[key] = Array.isArray(result.data)
                                ? result.data
                                : __assign({}, result.data);
                        }
                        resolve(result.data);
                    })
                        .catch(function (error) {
                        // Pass caught error to global handler to ensure that it is properly logged in case it is code error
                        getErrorHandler().handleError(error, "Bn3rc" /* Bn3rc */);
                        // NotFound (404) is expected result indicating that storage does not contain
                        // value for requested key; this is valid response
                        var xhrError = error;
                        if (xhrError &&
                            xhrError.httpResponse &&
                            xhrError.httpResponse.status === 404 /* NotFound */) {
                            // Return undefined as indicator that value has not been found
                            resolve(undefined);
                            return;
                        }
                        reject("Failed to get value from user data storage for <" + key + "> key.");
                    });
                    return [2 /*return*/];
            }
        });
    }); });
}
//# sourceMappingURL=getUserStorageItem.js.map